import React from 'react';

import {lowerizeFirstLetter} from '../../string-utils';
import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
	name: string;
};

// {@item item-id, Название предмета на русском}
export const SpellPlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;
	return (
		<Link route={'spell'} params={{id}} title={title} className={linkClass('spell')}>
			<i>{title}</i>
		</Link>
	);
};
